document.addEventListener('DOMContentLoaded', () => {
    const nv = document.getElementById('nav');
    if (nv) {
        const toggleSc = () => {
            if (window.scrollY > 50) { 
                nv.classList.add('sc'); 
            } else { 
                nv.classList.remove('sc'); 
            }
        };
        window.addEventListener('scroll', toggleSc, { passive: true });
        toggleSc();
    }

    const initLanguageSwitcher = () => {
        // Desktop language selector
        const wrapper = document.querySelector('.ls-wrapper');
        const trigger = document.getElementById('HeaderLanguageTrigger');
        const form = document.getElementById('HeaderLanguageForm');

        if (wrapper && trigger && form) {
            const dropdown = wrapper.querySelector('.ls-dropdown');
            const hiddenInput = form.querySelector('input[name="language_code"]');
            const options = wrapper.querySelectorAll('.ls-option');

            const toggleDropdown = (open) => {
                const isOpen = open !== undefined ? open : !wrapper.classList.contains('is-open');
                if (isOpen) {
                    wrapper.classList.add('is-open');
                    if (dropdown) dropdown.removeAttribute('hidden');
                    trigger.setAttribute('aria-expanded', 'true');
                } else {
                    wrapper.classList.remove('is-open');
                    if (dropdown) dropdown.setAttribute('hidden', '');
                    trigger.setAttribute('aria-expanded', 'false');
                }
            };

            trigger.addEventListener('click', (e) => {
                if (trigger.hasAttribute('disabled')) return;
                e.stopPropagation();
                toggleDropdown();
            });

            // Close on click outside
            document.addEventListener('click', (e) => {
                if (!wrapper.contains(e.target)) {
                    toggleDropdown(false);
                }
            });

            // Close on Escape key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && wrapper.classList.contains('is-open')) {
                    toggleDropdown(false);
                    trigger.focus();
                }
            });

            // Option selection
            options.forEach(opt => {
                opt.addEventListener('click', (e) => {
                    e.preventDefault();
                    const langCode = opt.dataset.value;
                    if (langCode && hiddenInput && langCode !== hiddenInput.value) {
                        hiddenInput.value = langCode;
                        form.submit();
                    } else {
                        toggleDropdown(false);
                    }
                });
            });
        }

        // Mobile drawer language selector
        const mobileForm = document.getElementById('MobileLanguageForm');
        if (mobileForm) {
            const mobileInput = mobileForm.querySelector('input[name="language_code"]');
            const mobileButtons = mobileForm.querySelectorAll('.mm-lang-btn');

            mobileButtons.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const langCode = btn.dataset.value;
                    if (langCode && mobileInput && langCode !== mobileInput.value) {
                        mobileInput.value = langCode;
                        mobileForm.submit();
                    }
                });
            });
        }
    };

    initLanguageSwitcher();

    document.addEventListener('shopify:section:load', () => {
        initLanguageSwitcher();
    });
});

